export const DEFAULT_SCENE7_EXTENSION = `.scene7Src.dir.json/srcSet/false/width//height//aspectRatio//focalPoint//optimized/true/.cache`;

// Width/height match the native size of the static fallback logos in src/assets,
// so Scene7 renders at the same aspect ratio and never smart-crops them.
export const IIHS_LOGO_SCENE7_EXTENSION = `.scene7Src.dir.json/srcSet/false/width/960/height/150/aspectRatio//focalPoint//optimized/true/.cache`;
export const CR_LOGO_SCENE7_EXTENSION = `.scene7Src.dir.json/srcSet/false/width/508/height/160/aspectRatio//focalPoint//optimized/true/.cache`;

export const getScene7Extension = (scene7ConfigExt?: string): string => {
  let scene7extension = DEFAULT_SCENE7_EXTENSION;
  if (scene7ConfigExt) {
    scene7extension = scene7ConfigExt;
  }
  return scene7extension;
};

async function fetchImageSrc(url: string) {
  const promise = await fetch(url, {});
  const response = await promise?.json();

  if (promise.status >= 500) {
    console.error(
      response?.message || 'Error getting image from url: ' + url,
    );
  }
  return response?.src;
}

export async function fetchScene7Image(
  imageSrc: string,
  scene7extension?: string,
): Promise<string> {
  const extension = getScene7Extension(scene7extension);
  const imgSrcUrl = `${imageSrc}${extension}`;
  const newImgSrc = await fetchImageSrc(imgSrcUrl);
  return newImgSrc;
}
